<br>
<div class="page-wrapper">
    <div class="page-content pt-0 pe-2 ps-2">
        <div class="container-fluid">
            <div class="default_class">
                <div class="content-wrapper p-0">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card rounded shadow-lg">
                                    <div class="card-header  headerbg" style="border-bottom:3px solid #d8eff8;">
                                        <h5 class="mb-0 ">{{headingName.TripReport}}</h5>
                                    </div>
                                    <div class="card-body">
                                        <!-- <div class="text-right">
                                <button type="button" class="btn btn-primary mb-1"  data-toggle="modal"
                                    data-target="#myModal" (click)="add()" >Add</button>      
                            </div> -->
                                        <div >
                                            <table id="patreggraph" datatable
                                                class=" table-striped table-bordered mt-2 pt-2 table-sm small"
                                                style="width:100%">
                                                <thead class="top" style="background-color: #0d9bc4; color:#ffffff;">
                                                    <tr>
                                                        <!-- <th> USID</th> -->


                                                        <th> Driver Name </th>
                                                        <th> Worker Name </th>
                                                        <th> Bus No </th>
                                                        <th> Total Pickups </th>
                                                        <th> Total Boardings </th>
                                                        <th> Total Dropoffs </th>
                                                        <th> Date </th>


                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    <tr *ngIf="let item of table">
                                                        <td>{{item.driver_name }}</td>
                                                        <td>{{item.aayamma_name }}</td>
                                                        <td>{{item.bus_no }}</td>
                                                        <td>{{item.total_pickups }}</td>
                                                        <td>{{item.total_boardings  }}</td>
                                                        <td>{{item.total_dropoffs }}</td>
                                                        <td>{{item.date }}</td>                                              
                                                    </tr>



                                                </tbody>

                                            </table>
                                        </div>
                                        <!-- <div class="text-center">
                                            No Records to display
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>